import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class DeliverySitesResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: [{
                'delivery_site': {
                    'name': 'Stamford',
                    'location': {
                        'address': '333 Ludlow St',
                        'city': 'Stamford',
                        'postal_code': '',
                        'latitude': null,
                        'longitude': null,
                    },
                    'code': '001',
                    'customer': {
                        'code': '2345',
                        'fantasy_name': 'David',
                        'business_name': 'Sabre Corporation',
                        'taxpayer_identification_number': '334456338'
                    }
                }
            }],
            errors: []
        }
    }

    deliverySites() {
        return this.content().map(rawDeliverySite => ({
            name: rawDeliverySite.name,
            address: rawDeliverySite.location.address,
            city: rawDeliverySite.location.city,
            postalCode: rawDeliverySite.location.postal_code,
            latitude: rawDeliverySite.location.latitude,
            longitude: rawDeliverySite.location.longitude,
            code: rawDeliverySite.code,
            customer: this._customerFrom(rawDeliverySite.customer)
        }))
    }

    customers() {
        const rawCustomers = this.content().map(rawDeliverySite => rawDeliverySite.customer);

        return this._rawCustomersWithoutRepetitions(rawCustomers);
    }

    _customerFrom(rawCustomer) {
        return {
            code: rawCustomer.code,
            fantasyName: rawCustomer.fantasy_name,
            businessName: rawCustomer.business_name,
            taxpayerIdentificationNumber: rawCustomer.taxpayer_identification_number
        };
    }

    _rawCustomersWithoutRepetitions(rawCustomers) {
        return [...new Map(rawCustomers.map(rawCustomer =>
            [JSON.stringify(this._customerFrom(rawCustomer)), this._customerFrom(rawCustomer)])).values()];
    }
}